<rdrx-audio-controls class="tts-rdrx-audio-controls" (closeEvent)="onClose()"> </rdrx-audio-controls>
